import React from 'react';
import { User } from '@core/generated/gql-types';
import {
  CANDIDATE_SUMMARY_AI_DISCLAIMER,
  getWorkerCvSummary,
  isWorkerCvSummaryAiGenerated,
} from '@/modules/workers/utils/cvProfile.utils';

interface CvProfileDisplayProps {
  worker: User;
  showAiDisclaimer?: boolean;
  emptyMessage?: string;
}

const CvProfileDisplay: React.FC<CvProfileDisplayProps> = ({
  worker,
  showAiDisclaimer = false,
  emptyMessage = 'No candidate summary',
}) => {
  const summary = getWorkerCvSummary(worker);
  const isAiGenerated = isWorkerCvSummaryAiGenerated(worker);

  if (!summary) {
    return <p className="text-sm text-gray-500">{emptyMessage}</p>;
  }

  return (
    <div className="space-y-3">
      {summary ? (
        <p className="text-sm whitespace-pre-wrap text-gray-700">{summary}</p>
      ) : null}
      {showAiDisclaimer && summary && isAiGenerated ? (
        <p className="text-xs text-gray-500 italic">
          {CANDIDATE_SUMMARY_AI_DISCLAIMER}
        </p>
      ) : null}
    </div>
  );
};

export default CvProfileDisplay;
